import React from 'react';
import { Link } from 'react-router-dom';

import { Card, CardContent, Typography, IconButton, CardActionArea, ListItemSecondaryAction } from '@material-ui/core';
import { GetApp, PlayArrow } from '@material-ui/icons';

import { getServerFormattedDate } from '../../util/getFormattedDate';

const settlementListItem = ({ settlement, onDownloadSettlement }) => {
    return (
        <Card className="SettlementListItem">
            <CardActionArea style={{width: '100%'}} component={Link} to={`/settlement/${settlement.check_id}`}>
                <CardContent>
                    <Typography variant="body2">{getServerFormattedDate(settlement.check_date)}</Typography>
                    <Typography>${(+settlement.check_amount).toFixed(2)}</Typography>
                </CardContent>
                <ListItemSecondaryAction>
                    <IconButton onClick={(event) => { event.preventDefault(); onDownloadSettlement(settlement.check_id)}} title="Download" aria-label="Download">
                        <GetApp />
                    </IconButton>
                    <IconButton aria-label="View Details">
                        <PlayArrow />
                    </IconButton>
                </ListItemSecondaryAction>
            </CardActionArea>
        </Card>
    );
}

export default settlementListItem;